import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import { Pie,Line } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend,CategoryScale,LinearScale,LineElement,Title,PointElement} from 'chart.js';
Chart.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

let source = axios.CancelToken.source();

class Heading2 extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            totalkm: 0,
            totaldur: 0,
            sevendayvio:[],
            sevenday:[],
            headobj:{},
            headload:false,
            excute:false,
            msg:"",
        }
    }
    componentDidMount() {
        let baseurl = myconfig.getdashboard5;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    headobj: res.data,
                    headload: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    menuhidden=(event)=>{
        event.preventDefault();
        if(this.state.menu=="g-sidenav-show bg-gray-100")
            this.setState({
                menu:"g-sidenav-show bg-gray-100 g-sidenav-pinned"
            })
        else
            this.setState({
                menu:"g-sidenav-show bg-gray-100"
            })
    }
    btngetkm=async (event)=> {
        event.preventDefault();
        if (!this.state.excute) {
            this.setState({
                excute:true,
            })
            let baseurl = myconfig.getroutekm;
            let redirecttologin = myconfig.redirecttologin;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            let count=this.state.headobj.moving.length;
            for(let i=0; i<count; i++){
                let msg="(Executing "+(i+1)+" of "+count+" vehicles)";
                this.setState({
                    msg:msg,
                })
                await axios.post(baseurl, {
                    "sid": sid,
                    "user": user,
                    "vehid":this.state.headobj.moving[i].vehid,
                }, {cancelToken: source.token}).then(res => {
                    console.log(res.data)
                    if (res.data.auth == false) {
                        /*  window.localStorage.setItem("fas_sid", null);
                          window.localStorage.setItem("fas_username", null);
                          window.localStorage.setItem("fas_name", null);
                          var win = window.open(redirecttologin, "_self");*/
                    } else if (res.data.success == false) {
                        Swal.fire({
                            title: 'Error!',
                            text: res.data.message,
                            icon: 'error',
                            confirmButtonText: 'Okay'
                        })
                    } else {
                        let temp=this.state.headobj;
                        let temp2=temp.moving.map(value=>{
                            if(value.vehid==this.state.headobj.moving[i].vehid)
                                value.leftkm=res.data.km
                            return value;
                        })
                        temp.moving=temp2
                        this.setState({
                            headobj:temp,
                        })
                    }
                }).catch((e) => {
                    console.log(e.message);
                });
                console.log(this.state.headobj.moving[i])
            }
        }
    }
    main=()=> {
        let retdata = null;
        console.log(this.state.headobj)
        if(this.state.headload) {
            let arrivedcount=this.state.headobj.arrived.length;
            let movingcount=this.state.headobj.moving.length;
            let garagecount=this.state.headobj.garage.length;
            let total=arrivedcount+movingcount+garagecount;
            let aper=(100*arrivedcount)/total
            aper = Math.floor(aper);
            let mper=(100*movingcount)/total
            mper = Math.floor(mper);
            let gper=(100*garagecount)/total
            gper = Math.floor(gper);
            let chartlabel=Array();
            let chartvalue=Array();
            let datatablehead=this.state.headobj.summury.map(value=>{
                chartlabel.push(value.loc)
                let total=value.move+value.stop;
                chartvalue.push(total)
                return(
                    <tr>
                    <td>{value.loc}</td>
                    <td>{value.move}</td>
                    <td>{value.stop}</td>
                    <td>{total}</td>
                </tr>)
            })
            let datatablemoving=this.state.headobj.moving.map(value=>{
                return(<tr>
                    <td>{value.plateno}</td>
                    <td>{value.drivername}</td>
                    <td>{value.phoneno}</td>
                    <td>{value.avlloc}</td>
                    <td>{value.to}</td>
                    <td>{value.load}</td>
                    <td>{value.chab}</td>
                    <td>{value.remark}</td>
                    <td>{value.avltime}</td>
                    <td>{value.leftkm}</td>
                    <td>Moving</td>
                </tr>)
            })
            let datatablearrived=this.state.headobj.arrived.map(value=>{
                return(<tr>
                    <td>{value.plateno}</td>
                    <td>{value.drivername}</td>
                    <td>{value.phoneno}</td>
                    <td>{value.avlloc}</td>
                    <td>{value.to}</td>
                    <td>{value.load}</td>
                    <td>{value.chab}</td>
                    <td>{value.remark}</td>
                    <td>{value.avltime}</td>
                    <td>{value.leftkm}</td>
                    <td>Arrived</td>
                </tr>)
            })
            let datatableGaraje=this.state.headobj.garage.map(value=>{
                return(<tr>
                    <td>{value.plateno}</td>
                    <td>{value.drivername}</td>
                    <td>{value.phoneno}</td>
                    <td>{value.avlloc}</td>
                    <td>{value.to}</td>
                    <td>{value.load}</td>
                    <td>{value.chab}</td>
                    <td>{value.remark}</td>
                    <td>{value.avltime}</td>
                    <td>{value.leftkm}</td>
                    <td>Garage</td>
                </tr>)
            })

            let data = {
                labels: chartlabel,
                datasets: [
                    {
                        label: 'Heading Status',
                        data:chartvalue,
                        backgroundColor: [
                            'rgba(240, 166, 202, 1)',
                            'rgba(156, 137, 184,1)',
                            'rgba(240, 230, 239, 1)',
                            'rgba(241, 211, 2, 1)',
                            'rgba(22, 25, 37, 1)',
                            'rgba(199, 235, 240, 1)',
                            'rgba(76, 96, 133, 1)',
                        ],
                        borderColor: [
                            'rgba(240, 166, 202, 1)',
                            'rgba(156, 137, 184,1)',
                            'rgba(240, 230, 239, 1)',
                            'rgba(241, 211, 2, 1)',
                            'rgba(22, 25, 37, 1)',
                            'rgba(199, 235, 240, 1)',
                            'rgba(76, 96, 133, 1)',
                        ],
                        borderWidth: 1,
                    },
                ],

            };
            retdata = <>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="card  mb-4">
                                    <div className="card-body p-3">
                                        <div className="row">
                                            <div className="col-8">
                                                <div className="numbers">
                                                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Arrived <br /> Vehicles</p>
                                                    <h5 className="font-weight-bolder">
                                                        {arrivedcount}
                                                    </h5>
                                                    <p className="mb-0">
                                                        <span className="text-success text-sm font-weight-bolder">{aper}%</span>                                          </p>
                                                </div>
                                            </div>
                                            <div className="col-4 text-end">
                                                <div className="icon icon-shape bg-gradient-success shadow-success text-center rounded-circle">
                                                    <i className="ni ni-paper-diploma text-lg opacity-10" aria-hidden="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="card  mb-4">
                                    <div className="card-body p-3">
                                        <div className="row">
                                            <div className="col-8">
                                                <div className="numbers">
                                                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Moving <br /> Vehicles</p>
                                                    <h5 className="font-weight-bolder">
                                                        {movingcount}
                                                    </h5>
                                                    <p className="mb-0">
                                                        <span className="text-success text-sm font-weight-bolder">{mper}%</span>                                          </p>
                                                </div>
                                            </div>
                                            <div className="col-4 text-end">
                                                <div className="icon icon-shape bg-gradient-success shadow-success text-center rounded-circle">
                                                    <i className="ni ni-paper-diploma text-lg opacity-10" aria-hidden="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <div className="card  mb-4">
                                    <div className="card-body p-3">
                                        <div className="row">
                                            <div className="col-8">
                                                <div className="numbers">
                                                    <p className="text-sm mb-0 text-uppercase font-weight-bold">Garage <br /> Vehicles</p>
                                                    <h5 className="font-weight-bolder">
                                                        {garagecount}
                                                    </h5>
                                                    <p className="mb-0">
                                                        <span className="text-success text-sm font-weight-bolder">{gper}%</span>                                          </p>
                                                </div>
                                            </div>
                                            <div className="col-4 text-end">
                                                <div className="icon icon-shape bg-gradient-success shadow-success text-center rounded-circle">
                                                    <i className="ni ni-paper-diploma text-lg opacity-10" aria-hidden="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pt-2">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <div className="card z-index-2 h-100">
                            <div className="card-header pb-0 pt-3 bg-transparent">
                                <h6 className="text-capitalize">Heading Status</h6>
                                <p className="text-sm mb-0">
                                    <span className="font-weight-bold">Heading</span> Summary
                                </p>
                            </div>
                            <div className="card-body p-3">
                                <div className="chart">
                                    <Pie data={data}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <div className="card z-index-2 h-100">
                            <div className="card-header pb-0 pt-3 bg-transparent">
                                <h6 className="text-capitalize">Heading Data</h6>
                                <p className="text-sm mb-0">
                                    <span className="font-weight-bold">Heading</span> Detail
                                </p>
                            </div>
                            <div className="card-body p-3">
                                <div className="chart">
                                    <div className="dataTable-container  overflow-auto" style={{height: '400px'}}>
                                        <table className="table table-flush dataTable-table"
                                               id="products-list">
                                            <thead>
                                            <tr>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Location</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Moving</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Arrived</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Total</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {datatablehead}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pt-2">
                    <div className="col-lg-12 mb-4 mb-lg-0">
                        <div className="card z-index-2 h-100">
                            <div className="card-header pb-0 pt-3 bg-transparent">
                                <h6 className="text-capitalize">Report Data</h6>
                                <p className="text-sm mb-0">
                                    <span className="font-weight-bold"><a href="" onClick={this.btngetkm}> Get Left Millage</a> {this.state.msg}</span>
                                </p>
                            </div>
                            <div className="card-body p-3">
                                <div className="chart">
                                    <div className="dataTable-container  overflow-auto" style={{height: '400px'}}>
                                        <table className="table table-flush dataTable-table"
                                               id="products-list">
                                            <thead>
                                            <tr>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Plate No</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Driver Name</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Phone #</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2" style={{width:"24.11%"}}>From</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">To</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Cargo Type</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Chab Waybill #</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Remark</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Update Time</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Left Km</th>
                                                <th className="text-uppercase text-dark text-xxs font-weight-bolder opacity-7 ps-2">Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {datatablemoving}
                                            {datatablearrived}
                                            {datatableGaraje}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer pt-3  ">
                    <div className="container-fluid">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-6 mb-lg-0 mb-4">
                                <div className="copyright text-center text-sm text-muted text-lg-start">
                                    © 2022,
                                    made with <i className="fa fa-heart" aria-hidden="true"/> by
                                    <a href="#" className="font-weight-bold"> ZTS Ethiopia</a>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <ul className="nav nav-footer justify-content-center justify-content-lg-end">
                                    <li className="nav-item">
                                        <a href="#"
                                           className="nav-link text-muted">ZTS Ethiopia</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#"
                                           className="nav-link text-muted">About Us</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#"
                                           className="nav-link pe-0 text-muted">License</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        }
        return (<>{retdata}</>)
    }
    render() {
        return (
            <>
                <div className="min-height-300 bg-primary position-absolute w-100"></div>
                <div className={this.state.menu}>
                    <Nav type="heading2"/>
                    <main className="main-content position-relative border-radius-lg ">
                        {/* Navbar */}
                        <nav className="navbar navbar-main navbar-expand-lg  px-0 mx-4 shadow-none border-radius-xl z-index-sticky " id="navbarBlur" data-scroll="false">
                            <div className="container-fluid py-1 px-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                                        <li className="breadcrumb-item text-sm">
                                            <a className="text-white" href="#">
                                                <i className="ni ni-box-2" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item text-sm text-white"><a className="opacity-5 text-white" href="#">Dashboard</a></li>
                                    </ol>
                                    <h6 className="font-weight-bolder mb-0 text-white">Heading-2</h6>
                                </nav>
                                <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
                                    <a href="#" onClick={this.menuhidden} className="nav-link p-0">
                                        <div className="sidenav-toggler-inner">
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                            <i className="sidenav-toggler-line bg-white" />
                                        </div>
                                    </a>
                                </div>
                                <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                                    <div className="ms-md-auto pe-md-3 d-flex align-items-center">
                                        <div className="input-group">
                                            <span className="input-group-text text-body"><i className="fas fa-search" aria-hidden="true" /></span>
                                            <input type="text" className="form-control" placeholder="Type here..." />
                                        </div>
                                    </div>
                                    <ul className="navbar-nav  justify-content-end">
                                        <li className="nav-item d-flex align-items-center">
                                            <a href="" className="nav-link text-white font-weight-bold px-0">
                                                <i className="fa fa-user me-sm-1" />
                                                <span className="d-sm-inline d-none">ncapi</span>
                                            </a>
                                        </li>
                                        <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                                            <a href="#" className="nav-link text-white p-0" onClick={this.menuhidden}>
                                                <div className="sidenav-toggler-inner">
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                    <i className="sidenav-toggler-line bg-white" />
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        {/* End Navbar */}
                        <div className="container-fluid py-4">
                            {this.main()}
                        </div>
                    </main>
                </div>

            </>
        )
    }
}

export default Heading2;
